import { Box, Skeleton } from '@mui/material'
import React from 'react'

const ClaimLoadingState = () => {
  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '24px 16px',
        width: '100%',
      }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
          gap: '12px',
        }}
      >
        <Box>
          <Skeleton variant="circular" width={50} height={50} />
        </Box>
        <Box sx={{ width: '100%' }}>
          <Skeleton variant="text" width={'30%'} />
          <Skeleton variant="text" width={'70%'} />
        </Box>
      </Box>
      <Box
        sx={{
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'end',
          gap: '16px',
        }}
      >
        <Skeleton variant="text" width={'20%'} height={'26px'} />
        <Skeleton variant="text" width={'20%'} height={'26px'} />
      </Box>
    </Box>
  )
}

export default ClaimLoadingState
